import bricsEvents from './events';
import bricsCities from './cities';
import bricsTracks from './tracks';
import bricsWorkgroups from './workgroups';

const bricsReducers = {
  bricsEvents,
  bricsCities,
  bricsTracks,
  bricsWorkgroups,
};

export default bricsReducers;
